export const DISMISS_ALERT = 'DISMISS_ALERT';



// WEBPACK FOOTER //
// ./src/core/alerts/action-types.js